import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'exceeded',
  standalone: false,
})
export class ExceededPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? 'Yes' : 'No';
  }
}
